<template>
  <div class="course-class">
    <p>
      <span class="title">课程所属班级:</span>
      <span
        class="title name"
        @click="
          $router.push({
            name: 'ClassesDetail',
            params: { id: course.class_id },
          })
        "
      >
        {{ course.class_name }}
      </span>
      <img
        style="width: 5px"
        src="@/assets/images/course/class-course-right.png"
        alt=""
      />
    </p>
  </div>
</template>

<script>
export default {
  name: "CourseClass",
  props: {
    course: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style scoped lang="scss">
.course-class {
  background: #f7f7f7;
  border-radius: 6px;
  display: inline-block;
  padding: 8px 16px;
  margin-bottom: 16px;
  p {
    display: flex;
    align-items: center;
    .title {
      color: #333333;
      line-height: 22px;
      font-size: 14px;
      margin-right: 12px;
    }
    .name {
      color: #aa7e4a;
      margin-right: 16px;
      cursor: pointer;
    }
  }
}
</style>
